import { TYPES } from "./types";
import { userGroupService } from "../services/userGroupService";

export const getUserGroups = () => async (dispatch) => {
  try {
    dispatch({ type: TYPES.ACTION_GET_USER_GROUPS_LOADING });
    const result = await userGroupService.getUserGroups();
    const data = result.data.data;
    if (data) {
      dispatch({
        type: TYPES.ACTION_GET_USER_GROUPS_SUCCESS,
        payload: { data }
      });
    } else {
      dispatch({
        type: TYPES.ACTION_GET_USER_GROUPS_FAIL,
        payload: {}
      });
    }
  } catch (error) {
    dispatch({
      type: TYPES.ACTION_GET_USER_GROUPS_FAIL,
      payload: { message: error },
    });
  }
};

export const setUserGroups = (groups) => async (dispatch) => {
  try {
    dispatch({ type: TYPES.ACTION_SET_USER_GROUPS_LOADING });
    const result = await userGroupService.setUserGroups(groups);
    const data = result.data.data;
    if (data) {
      dispatch({
        type: TYPES.ACTION_SET_USER_GROUPS_SUCCESS,
        payload: { group: data }
      });
    } else {
      dispatch({
        type: TYPES.ACTION_SET_USER_GROUPS_FAIL,
        payload: {}
      });
    }
  } catch (error) {
    dispatch({
      type: TYPES.ACTION_SET_USER_GROUPS_FAIL,
      payload: { message: error },
    });
    throw error;
  }
};

export const updateUserGroup = (id, data) => async (dispatch) => {
  try {
    await userGroupService.updateUserGroup(id, data);
    // Optionally, you can dispatch fetchUserGroups() or a success action here
  } catch (error) {
    // Optionally, you can dispatch a fail action here
    throw error;
  }
}; 